import React from 'react';
import {Switch} from 'react-router-dom';
import {EzManageNavProvider} from './EzManageNavContext';

type EzManageNavProps = React.PropsWithChildren<{
  appName: string;
}>;

const EzManageNavSwitch: React.FC<EzManageNavProps> = ({appName, children}) => {
  return (
    <EzManageNavProvider appName={appName}>
      <Switch>{children}</Switch>
    </EzManageNavProvider>
  );
};

export default EzManageNavSwitch;
